import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-minutes-of-meeting',
  templateUrl: './minutes-of-meeting.component.html',
  styleUrls: ['./minutes-of-meeting.component.scss']
})
export class MinutesOfMeetingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
